import { cloneDeep } from 'lodash-es';
import { generateObjectHash } from './object-hash';
export class CacheController {
    enabled;
    cache;
    constructor(enabled) {
        this.enabled = enabled;
        this.cache = new Map();
    }
    get(key, context) {
        if (!this.enabled)
            return undefined;
        return this.cache.get(this.getCacheName(key, context));
    }
    set(key, context, value) {
        if (!this.enabled)
            return undefined;
        this.cache.set(this.getCacheName(key, context), value);
    }
    has(key, context) {
        return this.cache.has(this.getCacheName(key, context));
    }
    clear() {
        this.cache.clear();
    }
    generateContext(constext) {
        try {
            return cloneDeep(constext);
        }
        catch (err) {
            console.log('error in cache generateContext', err);
            return constext;
        }
    }
    getCacheName(key, context) {
        const hash = generateObjectHash(context);
        return key + '_' + hash;
    }
}
//# sourceMappingURL=cache.controller.js.map